import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import ScrollToTop from './ScrollToTop'
import { Provider as ContextProvider } from './Context'

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop>
      <ContextProvider>
        <App> </App>
      </ContextProvider>
    </ScrollToTop>
  </BrowserRouter>,
  document.getElementById('root')
)
